export default {
  SUPER_ADMIN: -1,  // 承認者
  ADMIN: 0,         // 管理者
  ARCHITECT: 1,     // 設計者
  GENERAL: 2,       // 一般
}
